import { Column, Grid, Spacer, Text } from "@bunnix/components";
import { topics } from "./store/topics.mjs";
import { ForEach, Show, useMemo } from "@bunnix/core";
import RegularNewsCard from "./cards/regular-news-card.mjs";
import CompactNewsCard from "./cards/compact-news-card.mjs";

export default function NewsPage(props = {}) {
  const { topic, news } = props;

  const topicName = useMemo(topic, (tid) => topics.filter(t => t.id === tid).at(0)?.name);
  const mostRecentNews = useMemo(news, (ns) => ns.slice(1, 5))
  const remainingNews = useMemo(news, (ns) => ns.slice(5))
  const firstNews = useMemo(news, (ns) => ns.at(0));

  const RenderTitle = () => Text(
    { fontSize: "x-large", fontWeight: "bold", textTransform: "uppercase", fontColor: "accent" }, topicName
  )

  const RenderHeroGrid = () => (
    Grid(
      { layout: "fixed", columns: [{ size: "auto" }, { size: "auto" }], gap: 12 },
      Show(firstNews, (n1) =>
        Column({ bg: "accent", minWidth: 240, minHeight: 240, rowSpan: "2", hover: "enlarge" },
          RegularNewsCard(n1)
        )
      ),
      ForEach(
        mostRecentNews,
        { key: "id" },
        (n) => Column({ bg: "dimmed", minWidth: 240, minHeight: 240, hover: "enlarge" },
          CompactNewsCard(n)
        ),
      )
    )
  )

  const RenderRemainingGrid = () => (
    Grid(
      { layout: "fixed", columns: [{ size: "auto" }, { size: "auto" }], gap: 12 },
      ForEach(
        remainingNews,
        { key: "id" },
        (n) => Column({ bg: "mutted", minWidth: 180, minHeight: 180, hover: "enlarge" },
          CompactNewsCard({ ...n, smallContents: true })
        ),
      )
    )
  )

  return (
    Column(
      RenderTitle(),
      RenderHeroGrid(),
      Spacer({ height: 48 }),
      RenderRemainingGrid()
    )
  )
}
